module.exports = __webpack_public_path__ + "static/media/addInventoryIcon.fd6f781d.svg";